import golfball from "../../images/golf-balls.png";
import golfcap from "../../images/golf-cap.png";
import golfclub from "../../images/golf-club.jpg";
import golfclubs from "../../images/golf-clubs.jpg";
import golfcart from "../../images/golf-golfcartpng.jpg";
import golfpud from "../../images/golf-pud.jpg";
import golfblue from "../../images/golf-starterpack-blue.png";
import golfgreen from "../../images/golf-starterpack-pasture.png";
import golflight from "../../images/golf-starterpack-full.png";
export default function Nostalgia() {
  return (
    <div>
      <div className="header">
        <h1>Golf Starter Pack</h1>
        <p>
          This was a personal project that over the course of a week in June
          2022 just in time for my dad's birthday.
        </p>
        <div className="three-column-img">
          <img className="small-img" src={golfball} />
          <img className="small-img" src={golfcap} />
          <img className="small-img" src={golfclub} />
        </div>
        <div className="three-column-img">
          <img className="small-img" src={golfclubs} />
          <img className="small-img" src={golfcart} />
          <img className="small-img" src={golfpud} />
        </div>
        <div className="three-column-img">
          <img className="small-img" src={golfblue} />
          <img className="small-img" src={golfgreen} />
          <img className="small-img" src={golflight} />
        </div>
      </div>
    </div>
  );
}
